module.exports = __webpack_public_path__ + "img/logomain.png";